import React from "react";
import { SurveyResponse } from "src/components/survey/SurveyFormModel";
import { Pair } from "src/components/survey/ApplicationIdentity/model/utils";
import { DisplayLabels } from "src/components/survey/AccessControl/section/util";
import { TEST_IDS } from "shared/fields";
import { Box } from "@amzn/awsui-components-react-v3";

export const anvilId = (application: SurveyResponse): Pair => ({
    label: DisplayLabels.ANVIL_ID,
    testId: TEST_IDS.ACCESS_CONTROL_SECTION.ANVIL_ID,
    value: application.appInfo.review.anvilId || <Box variant="span">&mdash;</Box>,
});
